<template>
  <div class="introduce">
    <toolbar>
      <div class="menu_list">
        <ul>
          <li
            v-for="item in siteList"
            @click="changeSite(item)"
            :style="{color: item.id==c_SiteId ? '#333' : '#fff'}"
            :key="item.id"
          >
            <Icon type="md-code" v-if="c_SiteId!=item.id" />
            <Icon type="md-code-working" v-if="c_SiteId==item.id" />
            {{item.name}}
          </li>
        </ul>
      </div>
    </toolbar>
    <div class="content">
      <div class="box_text">
        <div class="left_img">
          <img :src="siteDeilsMap.fullPicUrl || siteDeilsMap.imgUrl" alt />
        </div>
        <div class="right_text">
          <div class="title">站点介绍</div>
          <div class="list">
            <ul>
              <li>
                <div class="item_key">站点名称：</div>
                <div class="item_value" >{{ siteDeilsMap.name || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">站点负责人：</div>
                <div class="item_value">{{ siteDeilsMap.managerInfo || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">创建时间：</div>
                <div class="item_value">{{ siteDeilsMap.createDate || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">站点介绍：</div>
                <div class="item_value">{{ siteDeilsMap.remark || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">环保设施：</div>
                <div class="item_value">{{ siteDeilsMap.environmentalFacilities || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">处 理 量：</div>
                <div class="item_value">{{ siteDeilsMap.airflow || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">处理对象：</div>
                <div class="item_value">{{ siteDeilsMap.processingObject || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">处理工艺：</div>
                <div class="item_value">{{ siteDeilsMap.processingTreatment || '暂无' }}</div>
              </li>
              <li>
                <div class="item_key">排放标准：</div>
                <div class="item_value">{{ siteDeilsMap.emissionStandard || '暂无' }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Spin fix v-show="loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss">
.introduce {
  width: 100%;
  height: 100%;
  .content {
    padding: 0 1em;
    padding-bottom: 1em;
    width: 100%;
    height: calc(100% - 5.5em);
    position: relative;

    .box_text {
      background: #fff;
      height: 100%;
      border: 1px solid #ccc;
      overflow: hidden;
      display: flex;
      .left_img {
        // background-color: #ddd;
        height: 100%;
        width: 60%;
        min-width: 60%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 90%;
        }
      }
      .right_text {
        height: 100%;
        padding: 1em 0;
        .title {
          font-size: 2em;
        }
        .list {
          margin-top: 1em;
          padding-left: 1em;
          padding-right: 1em;
          ul {
            li {
              display: flex;
              margin-bottom: 1em;
              text-align: left;
              .item_key {
                font-weight: bolder;
                color: #222;
                white-space: nowrap;
              }
              .item_value {
               white-space: wrap;
              }
            }
          }
        }
      }
    }
  }
  .menu_list {
    width: 100%;
    ul {
      display: flex;
      li {
        margin-right: 1em;
        background-color: #3fc87c;
        color: #fff;
        padding: 0.375em 0.625em;
        border-radius: 0.21875em;
        cursor: pointer;
        display: flex;
        align-items: center;
        i {
          font-size: 1.25em;
          margin-right: 0.25em;
        }
      }
    }
  }
}
</style>

<script>
import { timeStamp } from "../../../util/common/date";
import toolbar from "../toolBar.vue";

export default {
  data() {
    return {
      // 站点列表
      siteList: [],
      // 当前选中站点id
      siteNow: null,
      // 内容区loading
      loading: false,
      // 选中站点详情
      siteDeilsMap: {},
    };
  },
  components: {
    toolbar,
  },
  computed: {
    c_SiteId() {
      if (this.siteNow) {
        return this.siteNow.id;
      } else {
        return null;
      }
    },
  },
  created: async function () {
    // 获取站点列表
    await this.getSiteEnum();
    // 获取站点详情
    this.getSiteDeils();
  },
  methods: {
    // 获取站点枚举值
    getSiteEnum() {
      return new Promise((resovle, reject) => {
        this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then((res) => {
          if (res.code == 0) {
            this.siteList = res.data;
            this.siteNow = this.siteList[0] || {};
            resovle();
          } else {
            this.$Notice.warning({
              title: "获取站点枚举失败",
              desc: res.message || "请联系管理员",
            });
          }
        });
      });
    },
    changeSite(site) {
      this.siteNow = site;
      this.getSiteDeils();
    },
    // 获取站点详情
    getSiteDeils() {
      this.$api.Deploy.getSiteList({ content: { mn: this.siteNow.mn } }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0 && res.data.list.length != 0) {
          this.siteDeilsMap = res.data.list[0];
          if (this.siteDeilsMap.managerInfo) {
            let arr = JSON.parse(this.siteDeilsMap.managerInfo);
            if (typeof arr == "object") {
              this.siteDeilsMap.managerInfo = arr
                .map((okk) => {
                  return okk.name;
                })
                .join();
            }
          }

          this.siteDeilsMap.createDate = timeStamp(
            this.siteDeilsMap.createDate
          );
        } else {
          this.$Notice.warning({
            title: "获取站点详情失败",
            desc: res.message || "请联系管理员",
          });
        }
      });
    },
  },
};
</script>